<template>
	<div>
		<el-form ref="form" :model="form" :rules="rules" size="small" label-position="right" label-width="200px" :disabled="isEdit">
			<el-row :gutter="20">
				<el-col :span="12">
					<el-form-item label="项目名称" prop="xmmc">
						<el-input v-model.trim="form.xmmc"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="项目规模指标" prop="xmgmzb">
						<el-input v-model.trim="form.xmgmzb"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="项目地址" prop="xmdz">
						<el-input v-model.trim="form.xmdz"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="开始时间" prop="kssj">
						<el-date-picker
							v-model="form.kssj"
							type="date"
							value-format="yyyy-MM-dd"
							placeholder="请选择开始时间"
							style="width: 100%;"
						></el-date-picker>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="结束时间" prop="jssj">
						<el-date-picker
							v-model="form.jssj"
							type="date"
							value-format="yyyy-MM-dd"
							placeholder="请选择结束时间"
							style="width: 100%;"
						></el-date-picker>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="本人在工程项目所担任职务" prop="drzw">
						<el-input v-model.trim="form.drzw"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="完成项目的建筑业企业" prop="qymc">
						<el-input v-model.trim="form.qymc"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="负责资质类别" prop="zzCode">
						<el-select v-model="form.zzCode" placeholder="请选择" filterable>
							<el-option
								v-for="item in dictionarys.zzCodeList"
								:key="item.id"
								:label="item.dictionaryValues"
								:value="item.dictcode"
							></el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
	</div>
</template>

<script>
	import { getUuid } from '@/utils'
	import { queryCommonDictionary } from '@/api/dictionary/index'

	/**
	 * 技术负责人-工程业绩表单组件
	 */
	export default {
		name: 'JsfzrGcyjForm',
		components: {},
		props: {
			jsfzrId: {
				type: String,
				default: ''
			},
			isEdit: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				form: {
					xmmc: '',
					xmgmzb: '',
					xmdz: '',
					kssj: '',
					jssj: '',
					drzw: '',
					qymc: '',
					zzmc: '',
					zzCode: '',
					jsfzrId: '',
					id: ''
				},
				rules: {
					xmmc: [{ required: true, message: '请输入项目名称', trigger: 'blur' }],
					xmgmzb: [{ required: true, message: '请输入项目规模指标', trigger: 'blur' }],
					xmdz: [{ required: true, message: '请输入项目地址', trigger: 'blur' }],

					kssj: [
						{ required: true, message: '请选择开始时间', trigger: 'blur' },
						{ validator: this.startDate, trigger: 'blur' }
					],
					jssj: [
						{ required: true, message: '请选择结束时间', trigger: 'blur' },
						{ validator: this.endDate, trigger: 'blur' }
					],
					drzw: [{ required: true, message: '请输入本人在工程项目所担任职务', trigger: 'blur' }],
					qymc: [{ required: true, message: '请输入完成项目的建筑业企业', trigger: 'blur' }],
					zzCode: [{ required: true, message: '请选择负责资质类别', trigger: 'blur' }]
				},
				// 字典集合
				dictionarys: {
					// 资质类别字典
					zzCodeList: []
				}
			}
		},
		created() {},
		mounted() {
			this.handleInitDictionary()
		},
		methods: {
			/**
			 * 验证表单起始时间规则
			 */
			// 起始日期验证
			startDate: function(rule, value, callback) {
				if (!value) {
					callback(new Error('请选择开始时间！'))
				} else {
					// 如果结束日期没选，cb
					if (!this.form.jssj) {
						callback()
					} else {
						// 结束日期有，进行判断
						if (this.compareDate(value, this.form.jssj)) {
							// 如果起始在结束之前
							callback()
						} else {
							callback(new Error('开始时间不能在结束时间之后，请重新选择'))
						}
					}
				}
			},

			// 结束时间验证
			endDate(rule, value, callback) {
				if (!value) {
					callback(new Error('结束日期不能为空！'))
				} else {
					if (!this.form.kssj) {
						callback()
					} else {
						// 起始日期有
						if (this.compareDate(this.form.kssj, value)) {
							callback()
						} else {
							callback(new Error('结束时间不能在开始时间之前，请重新选择'))
						}
					}
				}
			},
			/**
			 * 比较两个日期
			 * @param start 起始日期
			 * @param end   结束日期
			 * @returns {boolean} true|false
			 */ compareDate(start, end) {
				return new Date(end).getTime() > new Date(start).getTime()
			},
			handleInitDictionary() {
				// 申报资质类别字典
				const params = {
					// 资质等级
					dictionaryId: '1',
					// 查询全部资质
					cxType: '2'
				}
				queryCommonDictionary(params)
					.then(response => {
						this.qualificationLoading = false
						const { data } = response

						if (data && data.length) {
							// 遍历数据给每一个子项添加selected属性
							data.forEach(item => {
								if (item.collection && Array.isArray(item.collection)) {
									item.collection.forEach(subItem => {
										subItem.selected = false
									})
								}
							})
							// zzCodeList为对象数组，现在要取出其中一项的code为107的
							this.dictionarys.zzCodeList = data.filter(item => item.code === '107')[0].collection
						}
					})
					.catch(error => {
						this.dictionarys.zzCodeList = []
					})
			},
			// 表单保存操作（每个列表对应的表单组件必须添加此方法，且必须同名）
			handleSaveInfo() {
				return new Promise(resolve => {
					this.$refs.form.validate(valid => {
						if (valid) {
							if (!this.form.id) {
								// 若无 uuid 则生成 uuid ，作为唯一标识
								this.form.id = getUuid()
							}
							this.form.jsfzrId = this.jsfzrId
							resolve(this.form)
						}
					})
				})
			}
		}
	}
</script>

<style scoped></style>
